<nav class="navbar sticky-top">
  <div class="col-12 p-2 text-end">
    <div class="">
      <div class="">
        <ul class="list-unstyled">
          <li class="dropdown ml-2">
            <a class="rounded-circle " role="button" tabindex="0" id="dropdownUser"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="avatar avatar-md avatar-indicators avatar-online">
                <img alt="avatar" src="./assets/images/avatar-img.jpg" class="rounded-circle">
              </div>
            </a>
            <div class="dropdown-menu pb-2" aria-labelledby="dropdownUser">
              <div class="">
                <ul class="list-unstyled">
                  <li><a class="dropdown-item" *ngIf="(user$ | async)?.userType == 'EMPLOYEE_ADMIN'"
                         [href]="ADMIN_PORTAL_LINK">Login as
                    Administrator</a></li>
                  <li><a class="dropdown-item" [routerLink]="PROFILE">My Profile</a></li>
                  <li><a class="dropdown-item" [routerLink]="SETTINGS">Settings</a></li>
                  <li><a class="dropdown-item" (click)="logout()">Logout</a></li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
